import React from 'react';
import IconArrowGrey from '../../../../../static/icons/icon_arrow_grey.svg';
import IconArrowWhite from '../../../../../static/icons/icon_arrow_white.svg';

const SelectionButton = ({ item, isSelected, clickHandler }) => {
    const arrowToDisplay = isSelected ? IconArrowWhite : IconArrowGrey;
    return (
        <button
            className="flex items-center justify-center lg:justify-between h-full w-full p-5"
            onClick={clickHandler.bind(this, item)}
            onKeyDown={clickHandler.bind(this, item)}
        >
            <span
                className={`${
                    isSelected ? 'text-white' : ''
                } text-card-text-color font-bold text-center text-14 md:text-base truncate`}
            >
                {item}
            </span>
            <img
                src={arrowToDisplay}
                alt={`Explore ${item}`}
                className="hidden lg:block"
            />
        </button>
    );
};

export default SelectionButton;
